import React, { useState } from "react";

import Divider from "@mui/material/Divider";
import { Box, Button, Stack, Typography } from "@mui/material";

import NavBar from "../../../NavBar";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./styles.css";
import { deleteDriverRequest } from "../../../redux/driver/action";
import { useResponsive } from "../../../hooks/useResponsive";
import { useRef } from "react";
import MenuBar from "../../menuBar";
import Carousel from "react-material-ui-carousel";
import ConfirmationDialog from "../../../components/ConfirmationDialog";
import { promoteOrDemoteUser } from "../../../redux/operator/action";
import { enqueueSnackbar } from "notistack";
import { stateListDriverRequest } from "../../../redux/driver/action";
import { useTranslation } from "react-i18next";
import SnackbarConfig from "../../../utils/snackbarConfig";

const DriverDetails = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lgUp = useResponsive("up", "lg");
  const { t } = useTranslation();

  const driverData = location?.state;
  const { stateObject } = useSelector((state) => state.driverReducer);

  React.useEffect(() => {
    dispatch(stateListDriverRequest({}, (response) => {}));
  }, []);

  const [vehicleDetails] = useState({
    [t("commonLabels.text07")]: driverData?.firstName
      ? driverData?.firstName
      : "",
    [t("commonLabels.text08")]: driverData?.lastName
      ? driverData?.lastName
      : "",
    [t("commonLabels.text09")]: driverData?.userEmail
      ? driverData?.userEmail
      : "",
    [t("commonLabels.text10")]: driverData?.phone
      ? `${
          driverData?.phone?.intlDialCd ? driverData?.phone?.intlDialCd : "+1"
        } ${driverData?.phone?.phoneNumber}`
      : "",
    [t("commonLabels.text11")]: driverData?.addressLine1
      ? driverData?.addressLine1
      : "",
    [t("commonLabels.text12")]: driverData?.city ? driverData?.city : "",
    [t("commonLabels.text13")]: driverData?.stateCode
      ? stateObject?.["USA"]?.find(
          (item) => item?.code === driverData?.stateCode,
        )?.description
      : "",
    [t("commonLabels.text14")]: driverData?.postalCode
      ? driverData?.postalCode
      : "",
  });

  const [dialogProps, setDialogProps] = useState({
    isOpen: false,
    title: `${t("pages.profile.key07")} ?`,
    content: "",
    reset: () =>
      setDialogProps((prev) => ({
        ...prev,
        isOpen: false,
        content: "",
      })),
  });

  const deleteDriver = (userId) => {
    dispatch(
      deleteDriverRequest(userId, (response) => {
        if (response.statusCode === 200) {
          enqueueSnackbar(t("pages.driverDetails.text10"), {
            variant: "success",
            autoHideDuration: 3000,
            action: SnackbarConfig,
          });
        }
        navigate(-1);
      }),
    );
  };
  const myRef = useRef({});

  const handleClickOpen = ({ content, handleContinue = undefined }) => {
    setDialogProps((prev) => ({
      ...prev,
      isOpen: true,
      content,
      handleContinue,
    }));
  };

  const handlePromoteToOwner = () => {
    dispatch(
      promoteOrDemoteUser(
        driverData?.userId,
        driverData?.roleCode,
        (apiResponse) => {
          setDialogProps({
            isOpen: false,
            content: "",
            reset: () =>
              setDialogProps((prev) => ({
                ...prev,
                isOpen: false,
                content: "",
              })),
          });
          if (apiResponse.statusCode === 200) {
            enqueueSnackbar(apiResponse.message, {
              variant: "success",
            });
            navigate(-1);
          } else {
            enqueueSnackbar(apiResponse.message, {
              variant: "error",
            });
          }
        },
      ),
    );
  };
  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <NavBar
        title={t("pages.driverDetails.pageHeading")}
        redirectTo={"/editDriver"}
        redirectToData={driverData}
        isReDirect={false}
        myRef={myRef}
        enableMenu={false}
      />
      <MenuBar myRef={myRef} />
      <Box
        sx={{
          width: `${lgUp ? "75%" : "100%"}`,
          margin: "auto",
          justifyContent: "center",
          minHeight: "60vh",
          overflow: "auto",
        }}
      >
        <Carousel>
          {driverData?.fileUploadResponse?.map((driverDetails) => (
            <img
              src={driverDetails?.tempUrls}
              style={{
                width: "100%",
                maxHeight: "250px",
                minHeight: "100px",
                objectFit: "contain",
                marginTop: 5,
              }}
              alt=""
            />
          ))}
        </Carousel>
        <div style={{ marginTop: "2%" }}>
          {Object.keys(vehicleDetails).map((vd, index) => {
            return (
              <div key={index}>
                {" "}
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ justifyContent: "space-between", padding: 2 }}
                >
                  <Typography>{vd}</Typography>
                  <Typography
                    sx={{
                      fontFamily: "Segoe UI",
                      fontSize: 15,
                      fontWeight: 400,
                      textAlign: "right",
                      color: "#1D5AB9",
                    }}
                  >
                    {vehicleDetails[vd]}
                  </Typography>
                </Stack>
                <Divider width={"100%"} />
              </div>
            );
          })}
        </div>
      </Box>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        {driverData.userStatus === "ACTIVE" && (
          <Button
            variant="outlined"
            style={{
              alignSelf: "center",
              width: 174,
              height: 40,
              marginLeft: 88,
              alignItems: "center",
              margin: "auto",
              marginTop: 50,
              display: "flex",
              backgroundColor: "#fff",
              borderColor: "#8A8886",
              color: "#605E5C",
            }}
            onClick={() =>
              handleClickOpen({
                content:
                  driverData.roleCode === "OWNER"
                    ? t("pages.driverDetails.text03")
                    : t("pages.driverDetails.text04"),
                handleContinue: () => handlePromoteToOwner(),
              })
            }
          >
            <Typography
              variant="buttonText"
              color="common.buttonText"
              style={{ color: "#605E5C" }}
            >
              {driverData.roleCode === "OWNER"
                ? t("pages.driverDetails.text02")
                : t("pages.driverDetails.text01")}
            </Typography>
          </Button>
        )}

        <Button
          onClick={() => {
            handleClickOpen({
              content:
                driverData.roleCode === "OWNER"
                  ? t("pages.driverDetails.text05")
                  : t("pages.driverDetails.text06"),
              handleContinue: () => deleteDriver(driverData?.userId),
            });
          }}
          variant="contained"
          style={{
            alignSelf: "center",
            width: 128,
            height: 40,
            marginLeft: 88,
            alignItems: "center",
            margin: "auto",
            marginTop: 50,
            display: "flex",
          }}
        >
          <Typography variant="buttonText" color="common.buttonText">
            {t("commonLabels.text03")}
          </Typography>
        </Button>
      </div>
      {dialogProps.isOpen && <ConfirmationDialog {...dialogProps} />}
    </div>
  );
};

export default DriverDetails;
